import { render, staticRenderFns } from "./BlockEditorHeading1.vue?vue&type=template&id=17e0df38&"
import script from "./BlockEditorHeading1.vue?vue&type=script&lang=ts&"
export * from "./BlockEditorHeading1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports